var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"inspire"}},[_c('router-view'),_c('v-footer',{attrs:{"color":"indigo","app":""}},[_c('span',{staticClass:"white--text"},[_vm._v("Closeapp © 2019")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }